import { IPlayUIStateProps } from "../..";
import { IKeypadMapDispatchProps, IKeypadMapStateProps } from "./Keypad";
import {
  triggerAutoplaySettingsViewChangeRequest,
  triggerBetSettingsViewChangeRequest,
  triggerDefaultViewChangeRequest,
  triggerGameRulesViewChangeRequest,
  triggerQuickSpinChangeRequest
} from "./Keypad.actions";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): IKeypadMapStateProps => ({
  hidden: state.keypad.hidden,
  spinStarted: state.keypad.spinStarted,
  menuButtonDisabled: state.keypad.menuButtonDisabled,
  spinButtonDisabled: state.keypad.spinButtonDisabled,
  betButtonDisabled: state.keypad.betButtonDisabled,
  isFreeRoundsEnabled: state.freeRounds.enabled,
  isFreeSpinsEnabled: state.freeSpins.enabled,
  isDialogShowing: state.dialogs.showing,
  quickSpinEnabled: state.keypad.quickSpin.enabled,
  quickSpinAvailable: state.keypad.quickSpin.available,
  quickSpinActive: state.keypad.quickSpin.active,
  allowAutoplayStart: state.autoplay.allowAutoplayStart,
  autoplayAvailable: state.autoplay.available,
  autoplayRoundsSelected: state.autoplay.roundsSelected,
  autoplayRoundsLeft: state.autoplay.roundsLeft,
  autoplayRunning: state.autoplay.running,
  autoplayButtonDisabled: state.keypad.autoplayButtonDisabled,
  view: state.view,
  displayMode: state.displayMode
});

export const sharedMapDispatchToProps = (
  dispatch
): IKeypadMapDispatchProps => ({
  triggerDefaultViewChangeRequest: () =>
    dispatch(triggerDefaultViewChangeRequest()),

  triggerAutoplaySettingsViewChangeRequest: () =>
    dispatch(triggerAutoplaySettingsViewChangeRequest()),

  triggerBetSettingsViewChangeRequest: () =>
    dispatch(triggerBetSettingsViewChangeRequest()),

  triggerGameRulesViewChangeRequest: () =>
    dispatch(triggerGameRulesViewChangeRequest()),

  triggerQuickSpinChangeRequest: value =>
    dispatch(triggerQuickSpinChangeRequest(value))
});
